import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);

  const load = () => api.get("/notifications").then((r) => { setItems(r.data.notifications); setUnread(r.data.unread); }).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && unread > 0) {
      await api.post("/notifications/read").catch(() => {});
      setUnread(0);
      setItems((prev) => prev.map((i) => ({ ...i, read: true })));
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} data-testid="notification-bell" className="relative text-muted hover:text-ink transition-colors duration-200">
        <Bell size={18} />
        {unread > 0 && (
          <span data-testid="notification-badge" className="absolute -top-1.5 -right-1.5 h-4 min-w-[16px] px-1 grid place-items-center rounded-full bg-signal text-[10px] font-bold text-white">{unread}</span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-3 w-80 max-h-96 overflow-y-auto rounded-xl border border-white/10 bg-surface shadow-2xl z-50" data-testid="notification-dropdown">
          <div className="px-4 py-3 border-b border-white/10 label-mono text-faint sticky top-0 bg-surface">Notifications</div>
          {items.length === 0 ? (
            <p className="px-4 py-8 text-sm text-muted text-center">No notifications yet.</p>
          ) : items.map((n) => (
            <div key={n.id} className={`px-4 py-3 border-b border-white/5 text-sm ${n.read ? "text-muted" : "text-ink"}`}>
              <p className="leading-snug">{n.message}</p>
              <p className="text-[10px] text-faint font-mono mt-1">{new Date(n.created_at).toLocaleString("en-US")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
